const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/skjøte/$skjøteId/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId,
      skjøteId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].skjøte[":skjøteId"].$get({
      param: {
        tluxCaseId,
        skjøteId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch skjøte");
    }
    return {
      response: await res.json()
    };
  },
  head: ({
    loaderData
  }) => {
    // We can infer that this is a tresidig skjøte if we have any utsteder actors
    let skjøteType = "skjøte";
    if (loaderData != null && loaderData.response.status === "success") {
      skjøteType = loaderData.response.skjøte.document.utstederActorRegisterenhetAndelIndexes == null ? "skjøte" : "tresidig-skjøte";
    }
    return {
      meta: [{
        title: `Rediger ${skjøteType} | Alice & Bob`
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});